import { useEffect, useState } from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Swal from "sweetalert2";
import { shiftActions } from "../../sagas/shiftSlice";
import POSNumericKeypadModal from "./POSNumericKeypadModal";

const CloseShiftModal = ({ isOpen, toggle, currentShift, onCloseShift }) => {

    const [closingCash, setClosingCash] = useState(0);
    const [closingCard, setClosingCard] = useState(0);
    const [keypadOpen, setKeypadOpen] = useState(false);
    const [activeField, setActiveField] = useState(null); // "CASH" | "CARD"

    useEffect(() => {
        setClosingCash(0);
        setClosingCard(0);
    }, [])

    const handleConfirmCloseShift = () => {
        Swal.fire({
            title: "Confirmation de clôture",
            html: `
      <p>Êtes-vous sûr de vouloir <strong>clôturer ce shift</strong> ?</p>
      <hr/>
      <p><strong>Total Espèces :</strong> ${closingCash}</p>
      <p><strong>Total Chèque / Virement :</strong> ${closingCard}</p>
    `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Confirmer",
            cancelButtonText: "Annuler",
        }).then((result) => {
            if (result.isConfirmed) {
                onCloseShift({
                    closingCash,
                    closingCard,
                });
            }
        });
    };


    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                Clôture votre caisse {currentShift?.shiftCode}
            </ModalHeader>

            <ModalBody>
                <FormGroup>
                    <Label>Total Espèces</Label>
                    <Input
                        value={closingCash}
                        readOnly
                        inputMode="none"
                        className="pos-nokeyboard"
                        placeholder="Saisir le montant"
                        onClick={() => {
                            setActiveField("CASH");
                            setKeypadOpen(true);
                        }}
                    />
                </FormGroup>

                <FormGroup>
                    <Label>Total Chèque / Virement</Label>
                    <Input
                        value={closingCard}
                        readOnly
                        inputMode="none"
                        className="pos-nokeyboard"
                        placeholder="Saisir le montant"
                        onClick={() => {
                            setActiveField("CARD");
                            setKeypadOpen(true);
                        }}
                    />
                </FormGroup>
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Annuler
                </Button>

                <Button
                    color="danger"
                    onClick={handleConfirmCloseShift}
                    disabled={Number(closingCash) <= 0 && Number(closingCard) <= 0}
                >
                    Clôturer le shift
                </Button>
            </ModalFooter>
            <POSNumericKeypadModal
                isOpen={keypadOpen}
                toggle={() => setKeypadOpen(false)}
                title={
                    activeField === "CASH"
                        ? "Total Espèces"
                        : "Total Chèque / Virement"
                }
                value={activeField === "CASH" ? closingCash : closingCard}
                allowDecimal={true}
                onConfirm={(val) => {
                    const amount = Number(val || 0);
                    if (Number.isNaN(amount)) return;

                    if (activeField === "CASH") {
                        setClosingCash(amount);
                    }

                    if (activeField === "CARD") {
                        setClosingCard(amount);
                    }

                    setKeypadOpen(false);
                }}
            />
        </Modal>
    );

}

export default CloseShiftModal;
